<video #target class="video-js" controls muted playsinline preload="none"></video>
